<template>
  <div>
    <b-alert
      variant="danger"
      :show="error"
      class="mb-2"
    >
      <div class="alert-body text-center py-1">
        <feather-icon
          icon="AlertTriangleIcon"
          size="32"
          class="d-block mx-auto mb-50"
        />
        <div class="mb-25">
          {{ $t('dashboard.error.title') }}
        </div>
        <div class="text-muted font-small-2 mb-1">
          {{ $t('dashboard.error.hint') }}
        </div>
        <b-button
          variant="outline-danger"
          size="sm"
          @click="getDashboard"
        >
          {{ $t('common.retry') }}
        </b-button>
      </div>
    </b-alert>
    <b-row v-if="!error">
      <b-col cols="12">
        <counters />
      </b-col>
      <b-col cols="12">
        <stats-cards />
      </b-col>
      <b-col cols="12">
        <usage-card />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BAlert, BButton,
} from 'bootstrap-vue'
import Counters from '@/views/Dashboard/Counters.vue'
import StatsCards from '@/views/Dashboard/StatsCards.vue'
import UsageCard from '@/views/Dashboard/UsageCard.vue'

export default {
  name: 'Manager',
  components: {
    BRow,
    BCol,
    BAlert,
    BButton,
    Counters,
    StatsCards,
    UsageCard,
  },
  computed: {
    error() {
      return this.$store.getters['dashboard/error']
    },
  },
  watch: {
    // Sayaç etiketleri BE'den gelir; dil değişince yeni dilde yeniden çekilir.
    '$i18n.locale': 'getDashboard',
  },
  created() {
    this.getDashboard()
  },
  methods: {
    getDashboard() {
      this.$store.dispatch('dashboard/getDashboard')
    },
  },
}
</script>
